import { Component } from '@angular/core';
import { ParagraphDirective } from '../../shared/directives/paragraph.directive';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { CmsTextPipe } from '../../pipes/cms-text.pipe';

@Component({
  selector: 'app-not-logged-in',
  standalone: true,
  imports: [ParagraphDirective, RouterLink, CmsTextPipe, AsyncPipe],
  templateUrl: './not-logged-in.component.html',
  styleUrl: './not-logged-in.component.scss'
})
export class NotLoggedInComponent {

}
